import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CategoryConfig } from "./config/CategoryConfig";
import { TypeConfig } from "./config/TypeConfig";
import { MaterialConfig } from "./config/MaterialConfig";
import { ThicknessConfig } from "./config/ThicknessConfig";
import { DimensionConfig } from "./config/DimensionConfig";
import { DashboardSidebar } from "./DashboardSidebar";

export function StockConfig() {
  return (
    <div className="min-h-screen flex w-full overflow-hidden">
      <DashboardSidebar />
      <main className="flex-1 p-6 overflow-y-auto bg-[#1A1F2C]">
        <div className="max-w-[1400px] mx-auto space-y-6">
          <h2 className="text-2xl font-bold text-white mb-6">Configurações</h2>
          
          <Tabs defaultValue="categories" className="w-full">
            <TabsList className="w-full justify-start bg-[#222831] p-1 rounded-lg">
              <TabsTrigger 
                value="categories" 
                className="text-[#F2F2F2] data-[state=active]:bg-[#E60026] data-[state=active]:text-white hover:bg-[#E60026]/10 transition-colors"
              >
                Categorias
              </TabsTrigger>
              <TabsTrigger 
                value="types" 
                className="text-[#F2F2F2] data-[state=active]:bg-[#E60026] data-[state=active]:text-white hover:bg-[#E60026]/10 transition-colors"
              >
                Tipos
              </TabsTrigger>
              <TabsTrigger 
                value="materials" 
                className="text-[#F2F2F2] data-[state=active]:bg-[#E60026] data-[state=active]:text-white hover:bg-[#E60026]/10 transition-colors"
              >
                Materiais
              </TabsTrigger>
              <TabsTrigger 
                value="thicknesses" 
                className="text-[#F2F2F2] data-[state=active]:bg-[#E60026] data-[state=active]:text-white hover:bg-[#E60026]/10 transition-colors"
              >
                Espessuras
              </TabsTrigger>
              <TabsTrigger 
                value="dimensions" 
                className="text-[#F2F2F2] data-[state=active]:bg-[#E60026] data-[state=active]:text-white hover:bg-[#E60026]/10 transition-colors"
              >
                Dimensões
              </TabsTrigger>
            </TabsList>

            <TabsContent value="categories" className="mt-6">
              <CategoryConfig />
            </TabsContent>
            
            <TabsContent value="types" className="mt-6">
              <TypeConfig />
            </TabsContent>
            
            <TabsContent value="materials" className="mt-6">
              <MaterialConfig />
            </TabsContent>
            
            <TabsContent value="thicknesses" className="mt-6">
              <ThicknessConfig />
            </TabsContent>
            
            <TabsContent value="dimensions" className="mt-6">
              <DimensionConfig />
            </TabsContent>
          </Tabs>
        </div>
      </main>
    </div>
  );
}